<template>
  <nav class="navbar navbar-dark align-items-start navbar-vertical position-relative" :class="{show: show}">
    <div class="sidenav-wrapper">
      <div class="navbar-brand d-flex justify-content-start align-items-center bg-primary" :class="{show: show}">
        <LeadtributorCloudIcon :showText="show"/>
      </div>
      <ul class="navbar-nav">
        <li class="nav-item">
          <a @click="toggle" class="nav-link">
            <span class="menu-icon"><HamburgerIcon/></span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click="toggleNewLeadMenu">
            <span class="menu-icon"><NewLeadIcon/></span>
            <span class="menu-text" :class="{show: show}">{{ $t('navigation.newLead') }}</span>
          </a>
          <NewLeadNavigation :formData="newLeadFormData" :show="showNewLeadMenu"/>
        </li>
      </ul>
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link to="/icon-view" class="nav-link">
            <span class="menu-icon"><FindLeadsIcon/></span>
            <span class="menu-text" :class="{show: show}">{{ $t('navigation.findLeads') }}</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/" class="nav-link">
            <span class="menu-icon"><EntryIcon/></span>
            <span class="menu-text" :class="{show: show}">{{ $t('navigation.leadEntry') }}</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/information-view" class="nav-link">
            <span class="menu-icon"><OfferedIcon/></span>
            <span class="menu-text" :class="{show: show}">{{ $t('navigation.offeredLeads') }}</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/card-view" class="nav-link">
            <span class="menu-icon"><AvailableIcon/></span>
            <span class="menu-text" :class="{show: show}">{{ $t('navigation.availableLeads') }}</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/login-view" class="nav-link">
            <span class="menu-icon"><InIcon/></span>
            <span class="menu-text" :class="{show: show}">{{ $t('navigation.leadsIn') }}</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/register-view" class="nav-link">
            <span class="menu-icon"><MarketsIcon/></span>
            <span class="menu-text" :class="{show: show}">{{ $t('navigation.markets') }}</span>
          </router-link>
        </li>
        <li class="nav-item notification">
          <router-link to="/collapsible-view" class="nav-link">
            <span class="menu-icon"><FindIcon/></span>
            <span class="menu-text" :class="{show: show}">{{ $t('navigation.findNewMarkets') }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { ref } from '@vue/composition-api'
import HamburgerIcon from '@/components/icons/HamburgerIcon'
import NewLeadIcon from '@/components/icons/NewLeadIcon'
import FindLeadsIcon from "@/components/icons/FindLeadsIcon";
import EntryIcon from '@/components/icons/EntryIcon'
import OfferedIcon from '@/components/icons/OfferedIcon'
import AvailableIcon from "@/components/icons/AvailableIcon";
import InIcon from '@/components/icons/InIcon'
import MarketsIcon from '@/components/icons/MarketsIcon'
import FindIcon from '@/components/icons/FindIcon'
import LeadtributorCloudIcon from '@/components/icons/LeadtributorCloudIcon'
import NewLeadNavigation from '@/components/layout/navigation/NewLead/NewLeadNavigation'

export default {
  name: 'NavbarVertical',
  props: {
    newLeadFormData: Object
  },
  components: {
    NewLeadNavigation,
    LeadtributorCloudIcon,
    HamburgerIcon,
    NewLeadIcon,
    FindLeadsIcon,
    EntryIcon,
    OfferedIcon,
    AvailableIcon,
    InIcon,
    MarketsIcon,
    FindIcon
  },
  setup () {
    const show = ref(false)
    const showNewLeadMenu = ref(false)

    function toggleNewLeadMenu () {
      showNewLeadMenu.value = !showNewLeadMenu.value
    }

    function toggle () {
      show.value = !show.value
    }

    return {
      toggle,
      show,
      toggleNewLeadMenu,
      showNewLeadMenu
    }
  }
}
</script>

<style lang="scss">
.v-application {
  .navbar-vertical {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1050 + 1;
    background-color: #878787;
    padding: 0;
    margin: 0;
    min-width: 64px;
    max-width: 64px;
    transition: all .2s ease-in-out;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: -1;
      background-color: $primary;
      content: '';
      height: 64px;
    }

    &.show {
      width: 250px;
      max-width: 100%;
    }

    .navbar-brand {
      align-items: center;
      padding-left: 17px;
      margin: 0;
      overflow: hidden;
      width: 100%;
      max-width: 64px;
      height: 64px;
      transition: all .2s ease-in-out;

      &.show {
        max-width: 100%;
      }

      svg {
        min-width: 164px;
        min-height: 34px;

        .toggle-element {
          transition: all .2s ease-in-out;
          opacity: 1;
        }

        .hide {
          opacity: 0;
        }
      }
    }

    .navbar-nav {
      + .navbar-nav {
        border-top: 1px solid #707070;
        margin-top: 64px;
      }

      .nav-item {
        border-bottom: 1px solid #707070;
        font-size: 16px;
        min-height: 63px;

        a.nav-link {
          display: flex;
          justify-content: start;
          align-items: center;
          padding: 0;
          cursor: pointer;
          color: $white;
          text-decoration: none;
          font-weight: 500;

          &:hover {
            color: $primary-hover;
          }

          .menu-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 64px;
            min-height: 63px;
          }

          .menu-text {
            text-align: left;
            overflow: hidden;
            padding-right: 0;
            white-space: nowrap;
            width: 100%;
            max-width: 0;
            transition: all .2s ease-in-out;

            &.show {
              padding-right: 45px;
              max-width: 100%;
            }
          }

          &:hover {
            .menu-icon {
              svg {
                .a {
                  stroke: $primary-hover;
                }

                .b {
                  fill: $primary-hover;
                }
              }
            }
          }

          &.router-link-active {
            position: relative;
            color: $primary-hover;

            &::before {
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              background-color: $primary-hover;
              content: '';
              width: 5px;
            }

            .menu-icon {
              svg {
                .a {
                  stroke: $primary-hover;
                }

                .b {
                  fill: $primary-hover;
                }
              }
            }
          }
        }

        &.notification {
          &::after {
            position: absolute;
            bottom: 4px;
            right: 4px;
            transition: all .2s ease-in-out;
          }
        }
      }
    }
  }
}
</style>
